import { StyleSheet } from 'react-native';

import { primitive } from 'styles/constants/primitives';

export const styles = StyleSheet.create({
  mainCard: {
    position: 'relative',
    borderRadius: 12,
    backgroundColor: primitive.$white,
  },
  progressContainer: {
    padding: primitive.spacing.$4,
  },
});
